/*eslint no-self-compare: "off"*/
Number.isNaN = Number.isNaN || function(value) {     
    return value !== value;
}